const SIZE_XS = '2px';
const SIZE_S = '4px';
const SIZE_M = '8px';
const SIZE_L = '16px';
const SIZE_XL = '24px';
const SIZE_2XL = '32px';
const SIZE_3XL = '48px';
const SIZE_4XL = '64px';
const SIZE_5XL = '96px';
const SIZE_6XL = '160px';
export function getHeight(transformer) {
    return Object.freeze({
        auto: transformer.height('auto'),
        xs: transformer.height(SIZE_XS),
        s: transformer.height(SIZE_S),
        m: transformer.height(SIZE_M),
        l: transformer.height(SIZE_L),
        xl: transformer.height(SIZE_XL),
        twoXl: transformer.height(SIZE_2XL),
        threeXl: transformer.height(SIZE_3XL),
        fourXl: transformer.height(SIZE_4XL),
        fiveXl: transformer.height(SIZE_5XL),
        sixXl: transformer.height(SIZE_6XL),
        six: transformer.height('6px'),
        thirty: transformer.height('30px'),
        fourtyFour: transformer.height('44px'),
        fourtySix: transformer.height('46px'),
        hundredTwenty: transformer.height('120px'),
        threeHundred: transformer.height('300px'),
    });
}
export function getMaxHeight(transformer) {
    return Object.freeze({
        sixtyPercent: transformer.maxHeight('60%'),
    });
}
export function getMinHeight(transformer) {
    return Object.freeze({
        m: transformer.minHeight(SIZE_3XL),
        xl: transformer.minHeight(SIZE_5XL),
        fourXl: transformer.minHeight(SIZE_4XL),
    });
}
export function getWidth(transformer) {
    return Object.freeze({
        xs: transformer.width(SIZE_XS),
        s: transformer.width(SIZE_S),
        m: transformer.width(SIZE_M),
        l: transformer.width(SIZE_L),
        xl: transformer.width(SIZE_XL),
        twoXl: transformer.width(SIZE_2XL),
        threeXl: transformer.width(SIZE_3XL),
        fourXl: transformer.width(SIZE_4XL),
        fiveXl: transformer.width(SIZE_5XL),
        sixXl: transformer.width(SIZE_6XL),
        eightyPercent: transformer.width('80%'),
        six: transformer.width('6px'),
        fourtyFour: transformer.width('44px'),
        fiftySix: transformer.width('56px'),
        thirty: transformer.width('30px'),
        threeHundred: transformer.width('300px'),
    });
}
export function getMinWidth(transformer) {
    return Object.freeze({
        twoPercent: transformer.minHeight('2%'),
    });
}
